const keycloakErrorReducer = (state = null, action) => {
  if (action.type === 'SET_KEYCLOAK_ERROR') {
    return action.payload;
  }
  return state;
};

export default keycloakErrorReducer;
